import { combineReducers } from "redux";

const defaultNumber = [];
export const numbers = (state = defaultNumber, action) => {
    switch (action.type) {
        case 'SEND_FAX_NUMBER_CHANGE':
            console.log({ number: action.numbers })
            return action.numbers;
        case 'SEND_FAX_SUCCESS':
        case 'SEND_FAX_CANCEL':
            return defaultNumber;
        default:
            return state
    }
};

const defaultFiles = [];
export const files = (state = defaultFiles, action) => {
    switch (action.type) {
        case 'SEND_FAX_FILES_CHANGE':
            return action.files;
        case 'SEND_FAX_SUCCESS':
        case 'SEND_FAX_CANCEL':
            return defaultFiles;
        default:
            return state
    }
};

export default combineReducers({
    numbers,
    files,
});